import { cn } from '@askable/ui/lib/utils';

type UnreadBadgeProps = {
  isCollapsed: boolean;
  unreadCount: number;
};

export const UnreadBadge = ({ isCollapsed, unreadCount }: UnreadBadgeProps) => {
  return (
    <div
      className={cn(
        // Only the collapsed rail uses the dot — expanded rows carry the count
        // itself — so it is placed against the 28px square, sitting on the top
        // right corner of the icon inside it. The old 0.4rem inset was measured
        // against a full-width row and now lands over the glyph.
        //
        // The ring is a cut-out that has to match whatever the row is filled
        // with. Hover and open are --foreground washes a few percent over the
        // sidebar, so the sidebar itself is within a couple of percent of all
        // three states — close enough to read as a clean gap, where the old
        // --secondary was a card-layer token that haloed the badge.
        `absolute right-0.5 top-0.5 z-10 aspect-square h-[0.6rem] w-[0.6rem] min-w-0 scale-100 rounded-full bg-chart-1 ring-2 ring-sidebar`,
        !isCollapsed || unreadCount === 0 ? 'opacity-0' : 'opacity-100',
      )}
    />
  );
};
